module.exports = __webpack_public_path__ + "static/media/Architecture_38.737239ff.jpg";